export default __webpack_public_path__ + "static/media/icon-email-manager.eb9eb299.svg";